import React from 'react';
import { Navigate } from 'react-router-dom';

// Email settings now live in Admin → Integrations. This route is kept only so
// the Gmail/Outlook OAuth redirect (/email-settings?connected=gmail|error=…)
// keeps working — it forwards into the Integrations Email section, carrying the
// OAuth query string along so the success/error toast still fires.
export default function EmailSettings() {
  const q = window.location.search.replace(/^\?/, '');
  const target = `/admin?tab=integrations&section=email${q ? `&${q}` : ''}`;
  return <Navigate to={target} replace />;
}
